/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/top'

export default {
  async getSpecEventDetail(spFeatureId) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/features/${spFeatureId}/special-feature-detail`).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.error)
        }
      )
    })
  }
}